import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface LaunchDateFormFieldProps {}

export const LaunchDateFormField: React.FC<LaunchDateFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ launch_date: string }>()

  return (
    <FormField
      name="launch_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Launch Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              placeholder={'Choose a launch date...'}
              selected={value ? new Date(value) : undefined}
              onSelect={(value) =>
                value && setValue('launch_date', toISO8601(value), { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
